import { useEffect, useMemo } from 'react';
import { CuredApiPaths } from 'models/enums';
import Card from 'pages/InsightsPage/dashboards/Card';
import { FiltersForApiState } from 'pages/InsightsPage/dashboards/filtering/types';
import useFilteredData from 'pages/InsightsPage/dashboards/filtering/useFilteredData';
import BarGraph from 'pages/InsightsPage/visualizations/BarGraph';

type Props = {
    filtersForApi: FiltersForApiState;
};

const actionLabels: Record<string, string> = {
    transferred: 'Transferred',
    opted_out: 'Opted Out',
};

const ActionsTakenCard = ({ filtersForApi }: Props) => {
    const { getData, isError, isLoading, data } = useFilteredData({
        key: 'voice-dashboard/actions-taken',
        path: CuredApiPaths.REPORT_VOICE_CALL_ACTIONS_TAKEN,
    });

    useEffect(() => {
        getData(filtersForApi);
    }, [filtersForApi, getData]);

    // Transform data for horizontal bar chart
    const chartData = useMemo(() => {
        if (!data || typeof data !== 'object') return [];

        return Object.entries(data).map(([key, value]) => ({
            id: actionLabels[key] || key,
            value: Number(value) || 0,
        }));
    }, [data]);

    return (
        <Card isError={isError} isLoading={isLoading} label="Actions Taken" sx={{ paddingRight: 3, paddingLeft: 1 }}>
            <BarGraph
                data={chartData}
                layout="horizontal"
                leftLegendLabel=""
                bottomLegendLabel="count"
                useSingleColor={false}
                barSize={0.5}
            />
        </Card>
    );
};

export default ActionsTakenCard;
